import { ValueFormatter } from '../../../../../app/attributes';
import { ReportDetailMetricAggregate } from './reportMetricModel';
import { ReportDetailMetricItemProps } from './reportMetricProps';

export function buildMetricItemProps(
    formatter: ValueFormatter,
    item: ReportDetailMetricAggregate
): ReportDetailMetricItemProps {
    return {
        id: item.definition.id,
        title: item.definition.name,
        description: item.definition.description,
        plugin: {
            iconUrl: item.plugin.iconUrl!,
        },
        current: {
            label: item.summary.current.value.base
                ? formatter.format(item.definition.type, item.summary.current.value.base)
                : 'N/A',
        },
        change: {
            self: {
                label: item.summary.current.value.change
                    ? formatter.format('percent', item.summary.current.value.change)
                    : 'N/A',
            },
            peers: {
                label: item.summary.mid.value.change
                    ? formatter.format('percent', item.summary.mid.value.change)
                    : 'N/A',
            },
        },
    };
}
